<template>
  <a
    href="#"
    class="social-btn pass-btn"
    :style="loginButtonStyles"
    @click.prevent="showPasscodeV2Fields()"
  >
    <i v-show="baseData.flags.loginBtnIcons" class="fa fa-lock" />
    <span v-text="$t('passcode')" />
  </a>
</template>

<script>
  export default {
    name: 'PassCodeLoginV2',
    props: ['api', 'action', 'wftkn'],
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      loginButtonStyles() {
        return {
          background: this.loginButtonColor || '#636363',
          color: this.loginButtonTextColor || '#FFFFFF',
          'justify-content': this.loginButtonTextAlignment || 'flex-start',
        }
      },
      loginButtonTextAlignment() {
        return this.baseData.fonts.alignments.loginBtns
      },
      loginButtonColor() {
        return this.baseData.colors.loginBtns.passcodeV2Btn
      },
      loginButtonTextColor() {
        return this.baseData.colors.loginBtns.loginBtnText
      },
      showPasscodeV2FieldsPreview() {
        return this.baseData?.development?.editPasscodeV2 || false
      },
    },
    watch: {
      showPasscodeV2FieldsPreview(val) {
        if (val) {
          this.showPasscodeV2Fields()
        }
      },
    },
    methods: {
      showPasscodeV2Fields() {
        this.$eventHub.$emit('showPasscodev2', true)
      },
    },
  }
</script>

<style>
  .pass-btn {
    background: #636363;
  }
  .pass-btn:hover {
    background: #636363;
  }
</style>
